<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div>
      <button nbButton ghost (click)="cancel()" status="primary">
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'info' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('info')"
      >
        <nb-icon class="button-icon" icon="info-outline"></nb-icon>
        Thông tin
      </button>

      <button
        [ngClass]="menu == 'detail' ? 'button-menu active' : 'button-menu'"
        [status]="menu == 'detail' ? 'primary' : 'basic'"
        nbButton
        ghost
        nbTooltipPlacement="bottom"
        (click)="selectMenu('detail')"
      >
        <nb-icon class="button-icon" icon="calendar-outline"></nb-icon>
        Chi tiết
      </button>
    </div>

    <div>
      <button
        *ngIf="mode === 'edit'"
        nbButton
        outline
        status="warning"
        size="small"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
        (click)="closed()"
      >
        <nb-icon
          [icon]="loan.isClosed ? 'unlock-outline' : 'lock-outline'"
        ></nb-icon>
        {{ loan.isClosed ? "Mở Khóa" : "Khóa" }}
      </button>
    </div>

    <div *ngIf="!loan.isClosed">
      <button
        nbButton
        status="primary"
        size="small"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
        (click)="submit()"
      >
        <nb-icon icon="save-outline"></nb-icon>
        {{ "buttons.save" | translate }}
      </button>

      <button
        *ngIf="mode === 'edit'"
        nbButton
        status="danger"
        size="small"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
        (click)="remove()"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
        {{ "buttons.delete" | translate }}
      </button>
    </div>
  </nb-card-header>

  <nb-card-body [nbSpinner]="loan.isClosed" nbSpinnerStatus="danger">
    <p class="lorem text-danger description">
      {{ errMessages }}
    </p>

    <div *ngIf="menu === 'info'" class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group">
          <label class="label">
            <a (click)="openCustomers()" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              Chọn khách hàng
            </a>

            <a (click)="onNewCustomer()" class="text-success link">
              <nb-icon icon="plus-outline"></nb-icon>
              Tạo mới
            </a>
          </label>
        </div>

        <div class="form-group">
          <label *ngIf="loan.customerId !== '' && loan.customer" class="label">
            <a (click)="editCustomer()" class="text-primay link">
              <nb-icon icon="edit-outline"></nb-icon>
              Cập nhật thông tin khách hàng
            </a>
          </label>
        </div>

        <div class="form-group">
          <label class="label">Họ tên</label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.customer.fullName"
            [disabled]="loan.customerId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label">Địa chỉ</label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.customer.address"
            [disabled]="loan.customerId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label"> SĐT </label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.customer.mobile"
            [disabled]="loan.customerId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label"> CMND / CCCD </label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.customer.cardId"
            [disabled]="loan.customerId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label">Ngày cấp</label>
          <nb-form-field>
            <input
              nbInput
              shape="semi-round"
              [nbDatepicker]="cardIdDate"
              [(ngModel)]="loan.customer.cardIdDate"
              [disabled]="loan.customerId !== ''"
            />
            <nb-datepicker
              style="width: 120px"
              #cardIdDate
              format="dd/MM/yyyy"
            ></nb-datepicker>
          </nb-form-field>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group">
          <label class="label">
            <a (click)="openProducts()" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              Chọn mặt hàng
            </a>

            <a (click)="onNewProduct()" class="text-success link">
              <nb-icon icon="plus-outline"></nb-icon>
              Tạo mới
            </a>
          </label>
        </div>

        <div *ngIf="loan.productId != '' && loan.product" class="form-group">
          <label class="label">
            <a (click)="editProduct()" class="text-hint link">
              <nb-icon icon="edit-outline"></nb-icon>
              Cập nhật thông tin mặt hàng
            </a>
          </label>
        </div>

        <div class="form-group">
          <label class="label"> Tên hàng </label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.product.title"
            [disabled]="loan.productId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label"> Biển số / mã hàng </label>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.product.barcode"
            [disabled]="loan.productId !== ''"
          />
        </div>

        <div class="form-group">
          <label class="label"> Số máy / số khung / mô tả </label>
          <textarea
            nbInput
            fullWidth
            rows="2"
            class="form-control"
            [(ngModel)]="loan.product.description"
            [disabled]="loan.productId !== ''"
          ></textarea>
        </div>

        <div class="form-group">
          <label *ngIf="loan.productId !== ''" class="label">
            Loại xe / loại hàng
          </label>
          <input
            *ngIf="loan.productId !== ''"
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.product.categoryName"
            [disabled]="loan.productId !== ''"
          />

          <label *ngIf="loan.productId === ''" class="label">
            <a (click)="openCatalog('categories')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              Loại xe / loại hàng
            </a>
          </label>
          <nb-form-field *ngIf="loan.productId === ''" fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('categories')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="loan.product.categoryId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of categories" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label *ngIf="loan.productId !== ''" class="label"> Màu sắc </label>
          <input
            *ngIf="loan.productId !== ''"
            type="text"
            nbInput
            fullWidth
            class="form-control"
            [(ngModel)]="loan.product.colorName"
            [disabled]="loan.productId !== ''"
          />

          <label *ngIf="loan.productId === ''" class="label">
            <a (click)="openCatalog('colors')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              {{ "common.colors" | translate }}
            </a>
          </label>
          <nb-form-field *ngIf="loan.productId === ''" fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('colors')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="loan.product.colorId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of colors" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog('groupLoans')" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              Nhóm
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog('groupLoans')"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="loan.groupId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of groupLoans" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>

        <form [formGroup]="diaForm">
          <div class="form-group">
            <label class="label">Ngày nhận</label>
            <nb-form-field>
              <input
                nbInput
                shape="semi-round"
                [nbDatepicker]="finDate"
                formControlName="issueDate"
                [(ngModel)]="loan.issueDate"
              />
              <nb-datepicker
                style="width: 120px"
                #finDate
                format="dd/MM/yyyy"
              ></nb-datepicker>
            </nb-form-field>
          </div>

          <div class="form-group">
            <label class="label">Đáo hạn </label>
            <nb-form-field>
              <nb-select
                nbPrefix
                class="type-select"
                size="small"
                [(ngModel)]="loan.remindType"
                formControlName="remindType"
                status="primary"
                shape="semi-round"
              >
                <nb-option [value]="'day'"> Ngày </nb-option>
                <nb-option [value]="'week'"> Tuần </nb-option>
                <nb-option [value]="'month'"> Tháng </nb-option>
                <nb-option [value]="'year'"> Năm </nb-option>
              </nb-select>
              <input
                nbInput
                type="number"
                shape="semi-round"
                style="text-align: right"
                formControlName="remindPaidNumber"
                [(ngModel)]="loan.remindPaidNumber"
              />
            </nb-form-field>
          </div>

          <div class="form-group">
            <label class="label">Tiền đáo hạn </label>
            <input
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              placeholder="Nhập số tiền"
              [status]="loan.remindAmount > 0 ? 'primary' : 'danger'"
              formControlName="remindAmount"
              [(ngModel)]="loan.remindAmount"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>

          <div class="form-group">
            <div class="label">
              <label>{{ "common.note" | translate }}</label>
            </div>
            <textarea
              nbInput
              fullWidth
              rows="3"
              id="inputDescription"
              class="form-control"
              formControlName="note"
              [(ngModel)]="loan.note"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="label"> Số tiền nhận: </label>
            <input
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              placeholder="Nhập số tiền"
              [status]="loan.detailAmount > 0 ? 'primary' : 'danger'"
              formControlName="amount"
              [(ngModel)]="loan.detailAmount"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </form>
      </div>
    </div>

    <div *ngIf="menu === 'detail'" class="row">
      <div class="col-12">
        <ngx-view-loan-cover
          [mode]="'view'"
          [loan]="loan"
        ></ngx-view-loan-cover>
      </div>
    </div>

    <div *ngIf="menu === 'detail'" class="row">
      <div class="col-12">
        <p class="lorem text-danger description">
          {{ errMessagesDetail }}
        </p>
        <div class="table-detail table-responsive">
          <table class="table table-sm align-items-center table-striped">
            <thead>
              <tr>
                <th>Ngày đáo hạn</th>
                <th>Đã thu</th>
                <th>Ngày thu</th>
                <th>Số tiền</th>
                <th>Ghi chú</th>
                <th></th>
              </tr>

              <tr>
                <td>
                  <nb-form-field>
                    <input
                      nbInput
                      shape="semi-round"
                      [nbDatepicker]="issueDateDetail"
                      [(ngModel)]="paymentDetail.issueDate"
                    />
                    <nb-datepicker
                      #issueDateDetail
                      format="dd/MM/yyyy"
                    ></nb-datepicker>
                  </nb-form-field>
                </td>
                <td>
                  <nb-checkbox
                    [(ngModel)]="paymentDetail.isPaid"
                    [status]="paymentDetail.isPaid ? 'success' : 'danger'"
                  >
                  </nb-checkbox>
                </td>
                <td>
                  <nb-form-field>
                    <input
                      nbInput
                      shape="semi-round"
                      [nbDatepicker]="paymentDateDetail"
                      [(ngModel)]="paymentDetail.paymentDate"
                    />
                    <nb-datepicker
                      #paymentDateDetail
                      format="dd/MM/yyyy"
                    ></nb-datepicker>
                  </nb-form-field>
                </td>
                <td>
                  <input
                    type="text"
                    nbInput
                    shape="semi-round"
                    class="form-control"
                    placeholder="Nhập số tiền"
                    [status]="paymentDetail.amount > 0 ? 'primary' : 'danger'"
                    [(ngModel)]="paymentDetail.amount"
                    [ngxNumberFormat]="formatCurrency"
                  />
                </td>
                <td>
                  <textarea
                    nbInput
                    fullWidth
                    rows="1"
                    class="form-control"
                    [(ngModel)]="paymentDetail.comment"
                  ></textarea>
                </td>
                <td>
                  <button
                    nbButton
                    outline
                    size="small"
                    status="primary"
                    (click)="addPaymentDetail()"
                  >
                    <nb-icon icon="plus-outline"></nb-icon>
                    Thêm
                  </button>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of loanPaymentDetails; let i = index">
                <td>
                  <ngx-editor-date
                    [date]="item.issueDate"
                    (onChange)="datetimeChange($event, i, 'issueDate')"
                  >
                  </ngx-editor-date>
                </td>
                <td>
                  <nb-checkbox
                    [(ngModel)]="item.isPaid"
                    [status]="item.isPaid ? 'success' : 'danger'"
                  >
                  </nb-checkbox>
                </td>
                <td>
                  <ngx-editor-date
                    [date]="item.paymentDate"
                    (onChange)="datetimeChange($event, i, 'paymentDate')"
                  >
                  </ngx-editor-date>
                </td>
                <td>
                  <input
                    type="text"
                    style="width: 120px"
                    nbInput
                    shape="semi-round"
                    class="form-control"
                    placeholder="Nhập số tiền"
                    [status]="item.amount > 0 ? 'primary' : 'danger'"
                    [(ngModel)]="item.amount"
                    (ngModelChange)="sumTotalPaidAmount()"
                    [ngxNumberFormat]="formatCurrency"
                  />
                </td>
                <td>
                  <textarea
                    style="width: 150px"
                    nbInput
                    rows="1"
                    class="form-control"
                    [(ngModel)]="item.comment"
                  ></textarea>
                </td>
                <td>
                  <button
                    nbButton
                    shape="round"
                    ghost
                    status="danger"
                    size="small"
                    (click)="removePaymentDetail(i)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer> </nb-card-footer>
</nb-card>
